import React, { useCallback, useEffect, useLayoutEffect, useState } from "react";
import { Row, Col, Typography, Space, DatePicker } from "antd";

import { useNavigate } from "react-router-dom";
import { bookingWidgets } from "../ducks/service";
import { useFetchAsync } from "../../../../../hooks/useFetchAsync";
import { getBUList } from "../../../Contracts/ducks/actions";
import { useDispatch, useSelector } from "react-redux";
import { FilterDropDownList } from "./FilterDropDownList";

import { getPropertiesDrop } from "../../../Properties/ducks/actions";
import { Dayjs } from "dayjs";
import { rangePresets, usagesTypeOption } from "../../utili";
import { useDashboardFilterContext } from "../../hooks/DashboardFilterProvider";
import { formatString } from "../../../../../utils/formatString";
import { usePropertiesDrop } from "../../hooks/usePropertiesDrop";

const { Title } = Typography;

const FilterSection = React.memo((props: any) => {
  const { data: buAndPropertyList } = usePropertiesDrop();

  const body: any = { page: props?.dashboardkey }; // example payload

  const [labelOfUnit, setLabelOfUnit] = useState("All Business Unit");
  const [usageTypeLabel, setUsageLabel] = useState("All");
  const [labelOfProperty, setLabelOfProperty] = useState("All Properties");
  const [dashboardDropDownItems, setdashboardDropDownItems] = useState([]);
  const { data, isLoading, error } = useFetchAsync({
    fetchFn: useCallback(() => bookingWidgets(body), [props?.dashboardkey]),
  });

  useLayoutEffect(() => {
    const storedAccess = localStorage.getItem("login-response");
    if (!storedAccess) return;

    try {
      const dashboardAccess = JSON.parse(storedAccess);
      const dashboardPages = dashboardAccess?.dashboardPages ?? [];

      if (dashboardPages.length > 0) {
        const dashboardDropItems = dashboardPages.map((value) => ({
          key: value,
          link:
            value === "bookings"
              ? "/dashboard"
              : value === "renewals"
              ? "/renewal/dashboard"
              : "/maintenance/dashboard",
          label: formatString(value),
          value: value,
        }));
        setdashboardDropDownItems(dashboardDropItems);
      }
    } catch (error) {
      console.error("Failed to parse login-response from localStorage:", error);
    }
  }, []);

  props.setWidgetAccess && props.setWidgetAccess(data);

  const navigate = useNavigate();

  const handleMenuClick = (key) => {
    const selectedItem = dashboardDropDownItems.find((item) => item.key === key);
    if (selectedItem && typeof selectedItem.link === "string") {
      props?.setDashboardKey(key);
      navigate(selectedItem.link);
    }
  };

  const { properties = [], businessUnits = [] }: any = buAndPropertyList || {};
  const filters = useDashboardFilterContext();

  const getFiltersValues = (value, type) => {
    if (type === 1 && value) {
      filters?.updateFilters({ businessUnitId: value });
      let label = businessUnits?.find((item) => item?.value === value);
      setLabelOfUnit(label?.label);
    } else if (type === 2 && value) {
      filters?.updateFilters({ propertyId: value });
      let label = properties?.find((item) => item?.value === value);
      setLabelOfProperty(label?.label);
    } else if (type === 3 && value) {
      filters?.updateFilters({ usagesType: value });
      let label = usagesTypeOption?.find((item) => item?.value === value);
      setUsageLabel(label?.label);
    }
  };



  const { RangePicker } = DatePicker;

  const onRangeChange = (dates: null | (Dayjs | null)[], dateStrings: string[]) => {
    if (dates) {
      filters?.updateFilters({ startDate: dateStrings[0] });
      filters?.updateFilters({ endDate: dateStrings[1] });
    } else {
      filters?.updateFilters({ startDate: "all" });
      filters?.updateFilters({ endDate: "all" });
    }
  };


  return (
    <div
      style={{
        padding: "16px 24px",
        borderRadius: "8px",
      }}
    >
      <Row align="middle">
        <Col xs={3} md={3}>
          <Title
            level={3}
            style={{
              margin: 0,
              color: "#123A55",
              fontSize: "20px",
              fontWeight: "bold",
              letterSpacing: "1px",
            }}
          >
            DASHBOARD
          </Title>
        </Col>

        <Col xs={21} md={21} style={{ textAlign: "right" }}>
          <Space
            size="middle"
            wrap
            style={{
              display: "flex",
              justifyContent: "flex-end",
              flexWrap: "wrap",
              gap: "10px",
            }}
          >
            <FilterDropDownList
              label={props?.dashboardkey ? formatString(props?.dashboardkey) : "Bookings"}
              dataList={[...dashboardDropDownItems]}
              onClick={(e) => handleMenuClick(e)}
            />
            <FilterDropDownList
              label={usageTypeLabel}
              dataList={[...usagesTypeOption]}
              onClick={(e) => getFiltersValues(e, 3)}
            />

            <FilterDropDownList
              label={labelOfUnit}
              dataList={businessUnits}
              onClick={(e) => getFiltersValues(e, 1)}
            />
            <FilterDropDownList
              label={labelOfProperty}
              dataList={[...properties]}
              onClick={(e) => getFiltersValues(e, 2)}
            />

            <RangePicker style={{ borderRadius: "8px" }} presets={rangePresets} size="large" onChange={onRangeChange} />
          </Space>
        </Col>
      </Row>
    </div>
  );
});

export default FilterSection;
